module.exports = __webpack_public_path__ + "static/media/iplicit-logo.a7b0a840.png";